import axios from 'axios';
import { API_URL } from './api';

export const subscriptionService = {
    list () {
        console.log('subscriptionService: list');

        return axios
            .get(`${API_URL}/abonnementen`)
            .then((response) => {
                if (response.data.data)
                {
                    return response.data.data;
                }

                return response;
            });
    },

    create (formData) {
        console.log('subscriptionService: create');

        return axios
            .post(`${API_URL}/abonnementen`, formData)
            .then((response) => response);
    },

    update (id, formData) {
        console.log('subscriptionService: update');

        return axios
            .put(`${API_URL}/abonnementen/${id}`, formData)
            .then((response) => response);
    },

    stop (id, formData) {
        console.log('subscriptionService: stop', id);

        return axios
            .put(`${API_URL}/abonnementen/stop/${id}`, formData)
            .then((response) => response);
    },

    get (id) {
        console.log('subscriptionService: get', id);

        return axios
            .get(`${API_URL}/abonnementen/${id}`)
            .then((response) => {
                if (response.data.data)
                {
                    return response.data.data;
                }

                return response;
            });
    },
};

export default subscriptionService;
